import React from "react";

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 w-full flex items-center justify-between p-4 bg-primary shadow-md z-50 bg-opacity-100">
      <div className="flex items-center space-x-2">
        <img
          src="/arancia-logo.jpeg"
          alt="Arancia Logo"
          className="h-12 w-12 rounded-full"
        />
        <h1 className="font-kanit text-3xl text-light-green tracking-wide">
          Arancia Techologies
        </h1>
      </div>
      <ul className="hidden md:flex space-x-8">
        <li>
          <a
            href="#home"
            className="relative text-white text-lg font-semibold group"
          >
            Home
            <span className="absolute left-0 bottom-[-8px] w-0 h-0.5 bg-accent1 transform transition-all duration-300 group-hover:w-full"></span>
          </a>
        </li>
        <li>
          <a
            href="#about"
            className="relative text-white text-lg font-semibold group"
          >
            About
            <span className="absolute left-0 bottom-[-8px] w-0 h-0.5 bg-accent1 transform transition-all duration-300 group-hover:w-full"></span>
          </a>
        </li>
        <li>
          <a
            href="#services"
            className="relative text-white text-lg font-semibold group"
          >
            Services
            <span className="absolute left-0 bottom-[-8px] w-0 h-0.5 bg-accent1 transform transition-all duration-300 group-hover:w-full"></span>
          </a>
        </li>
        {/* <li>
          <a
            href="#contact"
            className="relative text-white text-lg font-semibold group"
          >
            Contact
            <span className="absolute left-0 bottom-[-8px] w-0 h-0.5 bg-white transform transition-all duration-300 group-hover:w-full"></span>
          </a>
        </li> */}
      </ul>
      <button className="md:hidden text-light-green text-lg font-semibold">
        Menu
      </button>
    </nav>
  );
};

export default Navbar;
